<template>
  <div class="is-flex">
    <div v-html="displayText"></div>
  </div>
</template>
<script>
export default {
  name: 'TableCellApplicantSkill',
  props: ['payload'],
  data () {
    return {
      applicantSkills: []
    }
  },
  computed: {
    displayText () {
      return this.applicantSkills.map(skill => {
        if (skill.skill.featured) {
          return `<span class="is-warning">${skill.skill.name}</span>`
        }
        return skill.skill.name
      }).join(', ')
    }
  },
  created () {
    this.getFullSkills()
  },
  methods: {
    async getFullSkills () {
      this.applicantSkills = await this.$network_utils.getApplicantSkills({ current_applicant_id: this.payload.resource_id })
    }
  }
}
</script>
